import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass({ loader: true })
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NotificationsManager = _resolveComponent("NotificationsManager")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "main" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_row, {
          align: "center",
          justify: "center",
          class: "pa-12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: "@/assets/assuresrv_logo_terracotta.png",
              "max-width": "300px",
              alt: "Assure cloud"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          align: "center",
          justify: "center",
          class: "pa-12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              size: "100",
              indeterminate: "",
              color: "primary"
            })
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _ctx.loggedIn === null]
      ]),
      _createVNode(_component_router_view),
      _createVNode(_component_NotificationsManager)
    ]),
    _: 1
  }))
}